// src/services/wsClient.ts
export const createAuthenticatedWebSocket = (url: string, token: string, rights: number) => {
  const socket = new WebSocket(url);

  // Store auth data on socket for use in handlers
  (socket as any)._authToken = token;
  (socket as any)._authRights = rights;
  (socket as any)._authenticated = false;

  return socket;
};
